export default function AVERAGE() {
  return (
    <div className="p-4">
      <h1>AVERAGE</h1>
    </div>
  );
}
